
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";

@Component({})
export default class OrderBackordered extends Vue {
  orderModule: OrderModule = getModule(OrderModule);
  items: any[] = [];
  localLoading: boolean = false;

  get currentOrder() {
    return this.orderModule.currentOrder;
  }

  async mounted() {
    await this.loadItems();
  }

  @Watch("currentOrder.number")
  async onOrderChanged() {
    await this.loadItems();
  }

  async loadItems() {
    if (!this.currentOrder || !this.currentOrder.number) return;
    this.localLoading = true;
    try {
      const orderNumber = Number(this.currentOrder.number);
      const [backorders] = await Promise.all([
        this.orderModule.hasBackorders(orderNumber)
      ]);
      this.items = [
        ...(backorders || []),
      ];
    } finally {
      this.localLoading = false;
    }
  }
}
